export const ORG_CHARTS_PRO_ONLY_MESSAGE =
  'Org charts are a benefit exclusively for The Information Pro subscribers.';
export const SUBSCRIBE_NOW = 'Subscribe now';
export const UPGRADE_TO_PRO = 'Upgrade to Pro';
